import type { IntlShape } from 'react-intl';
import type { FilterConfig, RangeSliderFilterConfig } from '@alltrails/denali/components/FilterBar';
import { buildRevampRangeSlider } from '../../utils/buildRevampRangeSlider';
import RangeSliderDropdownContent from './RangeSliderDropdownContent';

/**
 * Config for a bespoke range slider config used in explore.
 *
 * https://www.figma.com/design/xr7AP5Bd1HcO5syL0nNhwZ/Explore-Usability-H2-2026?node-id=215-22416&m=dev
 */
export default function buildRangeSliderDropdownConfig(config: RangeSliderFilterConfig, intl: IntlShape): FilterConfig {
  return {
    type: 'custom-dropdown',
    id: config.id,
    filterChip: config.filterChip,
    content: <RangeSliderDropdownContent rangeSlider={buildRevampRangeSlider(config.rangeSlider, intl)} />
  };
}
